import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

export const useSocket = () => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [status, setStatus] = useState('disconnected');
  const [partnerId, setPartnerId] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [chatType, setChatType] = useState(null);
  const [messages, setMessages] = useState([]);
  const socketRef = useRef(null);

  const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:5001';

  useEffect(() => {
    // Initialize socket connection
    const newSocket = io(serverUrl, {
      transports: ['websocket'],
      autoConnect: true,
    });

    socketRef.current = newSocket;
    setSocket(newSocket);

    // Socket event handlers
    newSocket.on('connect', () => {
      console.log('Connected to server');
      setIsConnected(true);
      setStatus('connected');
    });

    newSocket.on('disconnect', () => {
      console.log('Disconnected from server');
      setIsConnected(false);
      setStatus('disconnected');
      setPartnerId(null);
      setRoomId(null);
      setChatType(null);
      setMessages([]);
    });

    newSocket.on('waiting_for_match', (data) => {
      console.log('Waiting for match:', data);
      setStatus('waiting');
      setChatType(data.chatType);
    });

    newSocket.on('match_found', (data) => {
      console.log('Match found:', data);
      setStatus('matched');
      setPartnerId(data.partnerId);
      setRoomId(data.roomId);
      setChatType(data.chatType);
      setMessages([]);
    });

    newSocket.on('receive_message', (data) => {
      console.log('Message received:', data);
      setMessages(prev => [...prev, {
        id: Date.now(),
        text: data.message,
        sender: 'stranger',
        timestamp: data.timestamp
      }]);
    });

    newSocket.on('partner_disconnected', () => {
      console.log('Partner disconnected');
      setStatus('partner_disconnected');
      setPartnerId(null);
      setRoomId(null);
    });

    newSocket.on('disconnected', () => {
      console.log('Chat disconnected');
      setStatus('disconnected');
      setPartnerId(null);
      setRoomId(null);
      setChatType(null);
      setMessages([]);
    });

    return () => {
      newSocket.close();
    };
  }, [serverUrl]);

  const findMatch = (type) => {
    if (socket && isConnected) {
      console.log('Finding match for:', type);
      socket.emit('find_match', { chatType: type });
    }
  };

  const sendMessage = (message) => {
    if (socket && isConnected && partnerId) {
      console.log('Sending message:', message);
      socket.emit('send_message', { message });
      setMessages(prev => [...prev, {
        id: Date.now(),
        text: message,
        sender: 'me',
        timestamp: new Date().toISOString()
      }]);
    }
  };

  const nextPartner = () => {
    if (socket && isConnected) {
      console.log('Finding next partner');
      socket.emit('next_partner');
    }
  };

  const disconnectChat = () => {
    if (socket && isConnected) {
      console.log('Disconnecting chat');
      socket.emit('disconnect_chat');
    }
  };

  return {
    socket,
    isConnected,
    status,
    partnerId,
    roomId,
    chatType,
    messages,
    findMatch,
    sendMessage,
    nextPartner,
    disconnectChat
  };
}; 